import { render } from "./EditDmeNeeded.vue?vue&type=template&id=5d87bc1b&ts=true"
import script from "./EditDmeNeeded.ts?vue&type=script&lang=ts&external"
export * from "./EditDmeNeeded.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__